<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">List of AP TAX Correction  
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm" >Delete</b-button>
          <b-dropdown text="Posting" variant="primary mr-1" >
            <b-dropdown-item @click="posting" :disabled="(model.posting == 1)">Posting</b-dropdown-item>
            <b-dropdown-item @click="posting" :disabled="(model.posting != 1)">Un Posting</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="printjv" :disabled="(model.posting == 0)">Jurnal Voucher</b-dropdown-item>
            <b-dropdown-item @click="print" >Form Pajak</b-dropdown-item>
          </b-dropdown>


          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" >
        <b-col md="6">
            <b-row>
              <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>AP Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="Order Number"></b-form-input>
                    <b-input-group-prepend><span class="pt-2">Invoice Number &nbsp;</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.invoice" placeholder="Request Number"></b-form-input>
                  </b-input-group>
              </b-col>
                <b-col lg="3">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Outstanding &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-row>
              <b-col lg="9">
                  <b-input-group >
                    <b-input-group-prepend><label>AP Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Posting &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus"></b-form-select>
                    </b-input-group>
                </b-col>
            </b-row>            
        </b-col>
        <b-col md="6">
            <b-input-group >
              <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
              <b-form-input v-model="tblData.vendor" placeholder="Vendor/Supplier"></b-form-input>
                <b-form-input v-model="tblData.uraian" placeholder="Description" class="ml-1"></b-form-input>
            </b-input-group>
            <b-row>
              <b-col lg="9">
                <b-input-group >
                    <b-input-group-prepend><label>Purchase Order</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.po" placeholder="Purch. Order#" style="width:27% !important;"></b-form-input>
                    <b-input-group-prepend><span class="ml-1 pt-2 mr-1">Inv. DP/Termin</span></b-input-group-prepend>
                    <b-form-select v-model="tblData.tagihandp" :plain="true" :options="dataList.YesNoAll"></b-form-select>
                  </b-input-group>
                </b-col>
            </b-row>            
            <b-input-group >
                <b-input-group-prepend><label>AP Posting Group</label></b-input-group-prepend>
                <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups"></b-form-select>
                <b-input-group-prepend><span class="pt-2">Account# &nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.kodeacc" placeholder="AP Account Code"></b-form-input>
                  <b-input-group-append>
                        <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                  </b-input-group-append>
                  <b-input-group-append>
                        <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                  </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="tblDataItems"
        :fields="tblFields"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"><span v-if="(data.item.posting==1)">View</span><span v-else>Edit</span> </b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.posting==0)">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="(data.item.posting==1)">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPrintJv(data.item)" href="#" >Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" >Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(data.item.posting==1)"> Delete</b-dropdown-item>
        </b-dropdown>
      </template> 
        <template v-slot:cell(tanggalAdj)="data">
          {{ data.item.tanggalAdj | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(totalap)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{(data.item.totalap)|numFormat('0,0.00')}}
          </div>
          <div v-else> 
            {{(data.item.totalap)|numFormat('0,0.00')}}
          </div>
        </template>
      
        <template v-slot:cell(grossupAdj)="data">
          <span v-if="data.item.grossupAdj==1">Gross Up</span>
        </template>
        <template v-slot:cell(totalapAdj)="data">
          {{data.item.totalapAdj | numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(nettApAdj)="data">
          {{data.item.nettApAdj | numFormat('0,0.00')}}
        </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>        
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure about doing this?</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    <b-modal v-model="showReport" size="xl" scrollable  title="Preview as PDF" hide-footer>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
  </div>
</template>



<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import aptaxadjust from "../../apis/aptaxadjust";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      pagination: false,
      isLoading:false,
      showReport:false,
      isprintjv:false,
      reportUrl: null,
      items: [],
      limit:15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: 'tanggal',
        sortDesc: true,
        DimCol:'Dim1'
      },
      model:{},deleted:{},
      postGroups:[],selected:[],
      receivingStatus:[{ value: '1', text: 'Received'},{ value: '0', text: 'Not Received'},{ value: '', text: '--- ALL ---'}],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "action",
            thStyle: "width:30px",
            label: "",
          },
          {
            key: "tanggalAdj",
            thStyle: "width:90px",
            label: "Tax. Adjusment",
            sortable: true
          },
          {
            key: "nomor",
            thStyle: "width:150px",
            label: "AP. Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "AP. Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            sortable: true
          },
          {
            key: "invoice",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description"
          },
          {
            key: "po",
            label: "PO/SO #",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalap",
            label: "Total before Adjust",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "totalapAdj",
            label: "Total After Adjust",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "grossupAdj",
            thStyle: "width:40px",
            label: "Gross Up",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "nettApAdj",
            label: "Nett Adjust (+/-)",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     thStyle: "width:100px",
        //     label: dims[i].text,
        //     sortable: true
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    "tblData.page": function(newval) {
      this.data();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   

  },
  created: async function(){
      const accList = await aptaxadjust.postgroup();
      this.postGroups = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      this.data();
  },  
  sockets: {
        aptaxadjust: function (data) {
            const ada = this.tblDataItems.find(a => a.taxadjkey==data.taxadjkey)
            if (ada){
              for (var key in data) {
                ada[key] = data[key];
              }
              // for (var key in ada) {
              //   ada[key] = data[key];
              // }
            }

        },
        apinvdeleted: function (data) {
            const index= this.tblDataItems.findIndex(a => a.apinvkey==data.apinvkey)
            this.tblDataItems.splice(index, 1);

        },
    },    

  methods: {
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintJv(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.aptaxadj) {
            this.tblData[key] = filter.aptaxadj[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.aptaxadj.tgl1 || '';
          this.tblData.tgl2=filter.aptaxadj.tgl2 || '';

          this.showFilter=filtered;
          delete filter.aptaxadj;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await aptaxadjust.list(this.tblData);
                  this.pagination=true;
                  this.tblDataItems = list;
                  this.isLoading=false;  
                  // return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await aptaxadjust.list(this.tblData);
              this.pagination=true;
              this.tblDataItems = list;
              this.isLoading=false;  
              // return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }

    },
    search() {
      this.tblData.page=1;
      this.data();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.po=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.invoice=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'invoice', 'vendor', 'vendorcode', 'po', 'postgroup', 'posting'];
      let filtered = false;
      const aptaxadj={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              aptaxadj[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          aptaxadj.page=this.tblData.page;
          aptaxadj.limit=this.tblData.limit;
          aptaxadj.sortBy=this.tblData.sortBy;
          aptaxadj.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.aptaxadj=aptaxadj;
          this.$store.commit("filter", filter);
      }
    },    
    add(){
      this.saveFilter();
      router.push({name :"taxadmin.aptaxadjustfrm"});
    },
    edit: function() {
        if (this.model.taxadjkey) {
          this.saveFilter();
          router.push({name :'taxadmin.aptaxadjustfrm', params: { taxadjkey: this.model.taxadjkey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.taxadjkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await aptaxadjust.remove(this.model);
      // this.data();
        const index= this.tblDataItems.findIndex(r => (r.taxadjkey==this.model.taxadjkey));
        this.tblDataItems.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.taxadjkey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await aptaxadjust.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            // if ( error.errno==1644){
            //   this.model.posting=1;
            //   // this.data();
            // }
            this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await aptaxadjust.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    print: async function()
    {
      if (this.model.taxadjkey) {
          try {
              this.isprintjv=true;
                this.showReport=true;
              this.reportUrl= await aptaxadjust.print(this.model);
          } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjv: async function()
    {
      if (this.model.taxadjkey) {
          try {
              this.isprintjv=true;
                this.showReport=true;
              this.reportUrl= await aptaxadjust.printjv(this.model);
          } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    editjv: function() {
        if (this.model.apinvkey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggalAdj).format('YYYY-MM-DD');
            // router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomorAdj, tanggal, kodejurnal:'APINV', fsubkode2:'ap_tax_adjust',kodefield2:'taxadjkey',subkode2: this.model.taxadjkey}});
          router.push({name :'payable.editjvfrm', params: { nomor: this.model.nomorAdj, tanggal}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await aptaxadjust.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
